// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__17Fqo","left":"InfoRow_left__2U9hF"};